export default __webpack_public_path__ + "static/image2-d805a2a7ea0a4ad885689d1831d4b150.png";